// extracted by mini-css-extract-plugin
export var sliderRange = "_qj-2";
export var sliderRoot = "_qj-0";
export var sliderThumb = "_qj-3";
export var sliderTrack = "_qj-1";